import { parseImageValidationTarget } from "./image-validation-target";

const apps = new Map<string, symbol>();
const listeners = new Map<string, Set<() => void>>();
const versions = new Map<string, number>();
const rootListeners = new Set<() => void>();
let active = false;

export const hasFreeImageRouting = (): boolean => active;
export const freeImageRoutingVersion = (appID: string): number => versions.get(appID) ?? 0;
export function subscribeFreeImageRoutingRoots(listener: () => void): () => void {
    rootListeners.add(listener);
    return () => {
        rootListeners.delete(listener);
    };
}
export function subscribeFreeImageRouting(appID: string, listener: () => void): () => void {
    let set = listeners.get(appID);
    if (set === undefined) {
        set = new Set();
        listeners.set(appID, set);
    }
    set.add(listener);
    return () => {
        set.delete(listener);
        if (set.size === 0) listeners.delete(appID);
    };
}
function changed(appID: string): void {
    versions.set(appID, freeImageRoutingVersion(appID) + 1);
    const nextActive = apps.size > 0;
    if (active !== nextActive) {
        active = nextActive;
        for (const listener of rootListeners) listener();
    }
    for (const listener of listeners.get(appID) ?? []) listener();
}

/** The app lifecycle installs routing only when its native percentage flag is enabled. */
export function installFreeImageRouting(appID: string): symbol {
    const state = Symbol(appID);
    apps.set(appID, state);
    changed(appID);
    return state;
}

export function removeFreeImageRouting(appID: string, state: symbol): void {
    if (apps.get(appID) !== state) return;
    apps.delete(appID);
    changed(appID);
}

/** Stable per-app URLs preserve ImageKit transformations and never carry operator credentials. */
export function freeImageRoutingURL(
    appID: string,
    original: string,
    target: () => string,
    endpoint: () => string
): string {
    if (!apps.has(appID)) return original;
    return parseImageValidationTarget(target(), endpoint())?.forFreeApp(appID) ?? original;
}
